module.exports = __webpack_public_path__ + "assets/media/logo-prize.d1816b1a.svg";